import { configure, message, notification } from 'choerodon-ui';
import { notification as notificationPro } from 'choerodon-ui/pro';
import { Tooltip } from 'choerodon-ui/pro/lib/core/enum';
import CommonRenderEmpty from '../CommonRenderEmpty';
// import tableConfigure from './customized-configure/tableConfigure';
import defaultStorageConfigure from './defaultStorageConfigure/defaultStorageConfigure';
import uploadFileConfigure from './uploadFileConfigure/uploadFileConfigure';

export const globalConfigure = () => {
  // 配置提示信息位置
  notification.config({
    placement: 'bottomRight',
    bottom: 100,
    duration: 3, // 显示3s后关闭
  });
  notificationPro.config({
    placement: 'bottomRight',
    bottom: 100,
    duration: 3, // 显示3s后关闭
  });
  message.config({
    placement: 'top',
    top: 240,
  });
  const params = {
    fieldFocusMode: 'focus' as any,
    lookupCache: { maxAge: 1000 * 30 },
    modalOkFirst: false,
    drawerOkFirst: false,
    tooltip: Tooltip.overflow,
    renderEmpty: CommonRenderEmpty,
    useLookupBatch: ()=>{
      return false;
    },
  };

  configure(params);

  // 上传附件配置
  configure({
    attachment: uploadFileConfigure(),
  });

  defaultStorageConfigure();

  // 表格个性化配置
  // tableConfigure();
};
